import Cookies from "./core/hooks/Cookies";


export function getParam(s, q) {
    try {
        const match = s.match(`[?&]${q}=([^&]+)`);
        return match ? match[1] : '';
        //        return s.match(RegExp('(^|&)'+q+'=([^&]*)'))[2];
    } catch (e) {
        return '';
    }
}

export function calculateTrafficSource() {
    let source = '';
    let medium = '';
    let campaign = '';
    let term = '';
    let content = '';
    let campaignId = '';
    const search_engines = [
        ['bing', 'q'],
        ['google', 'q'],
        ['yahoo', 'q'],
        ['baidu', 'q'],
        ['yandex', 'q'],
        ['ask', 'q']
    ]; // List of search engines
    let ref = document.referrer;
    ref = ref.substr(ref.indexOf('//') + 2);
    let ref_domain = ref;
    let ref_path = '/';
    let ref_search = '';
    // Checks for campaign parameters
    const url_search = document.location.search;

    //      console.log(url_search.indexOf('utm_source'));
    //      console.log(getParam(url_search, 'gclid'));
    //      console.log(url_search);

    // Note for future: client can have both utm parameters and gclid values. it shouldn't be if/else.
    if (url_search.indexOf('utm_') > -1) {
        source = getParam(url_search, 'utm_source');
        medium = getParam(url_search, 'utm_medium');
        campaign = getParam(url_search, 'utm_campaign');
        term = getParam(url_search, 'utm_term');
        content = getParam(url_search, 'utm_content');
        campaignId = getParam(url_search, 'utm_id');
    } else if (getParam(url_search, 'gclid')) {
        source = 'google';
        medium = 'cpc';
        campaign = '(not set)';
    } else if (ref) {
        // separate domain, path and query parameters
        if (ref.indexOf('/') > -1) {
            ref_domain = ref.substr(0, ref.indexOf('/'));
            ref_path = ref.substr(ref.indexOf('/'));
            if (ref_path.indexOf('?') > -1) {
                ref_search = ref_path.substr(ref_path.indexOf('?') + 1);
                ref_path = ref_path.substr(0, ref_path.indexOf('?'));
            }
        }
        medium = 'referral';
        source = ref_domain;
        // Extract term for organic source
        for (let i = 0; i < search_engines.length; i++) {
            if (ref_domain.indexOf(search_engines[i][0]) > -1) {
                medium = 'organic';
                source = search_engines[i][0];
                term = getParam(ref_search, search_engines[i][1]) || '(not provided)';
                break;
            }
        }
    }

    return {
        source,
        medium,
        campaign,
        term,
        content,
        campaignId
    };
}

export function getTrafficSource(cookieName, hostname) {
    const trafficSources = calculateTrafficSource();
    let overwriteTrafficSource = false;
    if (trafficSources.source.length === 0) {
        overwriteTrafficSource = true;
    }
    const source = trafficSources.source.length === 0 ? 'direct' : trafficSources.source;
    const medium = trafficSources.medium.length === 0 ? 'none' : trafficSources.medium;
    let campaign = trafficSources.campaign.length === 0 ? 'direct' : trafficSources.campaign;
    // exception
    if (medium === 'referral') {
        campaign = '';
    }
    const rightNow = new Date();
    const value = `source=${source}&medium=${medium}&campaign=${campaign}&term=${trafficSources.term
        }&content=${trafficSources.content}&campaignId=${trafficSources.campaignId
        }&overwritetrafficsource=${overwriteTrafficSource}&date=${rightNow
            .toISOString()
            .slice(0, 10)
            .replace(/-/g, '')}`;
    return value;
}
export function writeTrafficSourcesLogic(n) {
    let a = getTrafficSource(n, '.example.com'); // Insert your domain here
    a = a.replace(/\|{2,}/g, '|');
    a = a.replace(/^\|/, '');
    a = unescape(a);
    Cookies.set(n, a, 182); // Cookie expiration sets to 182 days
}
